import { GetterTree, MutationTree, Module } from 'vuex';
import { AuthClient } from "../api/ApiClientBase";
import * as api from "../api/ApiClient";
import Themes from "../api/Themes"
import router from "../routing/Router";
import { Profile } from "@/components/pages/security/SecurityProfileClasses";
import {DimensionSecurity, HierarchySecurity, TenantDTO} from "../api/ApiClient";
import { getALMFeatureFlagValue, getToastMessageFeatureFlagValue, getConfigureHomepagesAggridFeatureFlagValue, getAXLDownloadLinkFeatureFlagValue, getRebrandingStatusBadgesFeatureFlagValue, getHomepageCardDesignerFeatureFlagValue, getModalDialogsFeatureFlagValue, getTabbedbarFeatureFlagValue, getRightHandPanelsFeatureFlagValue, getLeftNavContextMenuFeatureFlagValue } from '@/services/getFeatureFlagService';

export interface ISecurityStore {
    UserName: string,
    AvatarVersion: number,
    Tenants: api.Tenant[] | null
    Tenant: api.Tenant | null,
    UserData: api.ExtendedUserData | null,
    ModuleSecurity: api.Module[] | null,
    ModuleList: Array<api.Module> | null,
    SelectedMember: number | null,
    ServerSelectionNeeded: boolean,
    Profiles: Array<Profile>,
    selectedProfile: Profile | null,
    selectedRole: HierarchySecurity | null,
    selectedHierarchy: DimensionSecurity | null,
    selectedHierarchyMembers: api.MemberInfo[] | null,
    previousTenantName: string | null,
    UserFirstLastName: string | null,
    almTenants: TenantDTO[] | null,
    AlmFeatureFlagValue: boolean,
    ToastMessageFeatureFlagValue: boolean,
    ConfigureHomepagesAggridFeatureFlagValue: boolean,
    AXLDownloadLinkFeatureFlagValue: boolean,
    RebrandingStatusBadgesFeatureFlagValue: boolean,
    HomepageCardDesignerFeatureFlagValue: boolean,
    ModalDialogsFeatureFlagValue: boolean,
    TabbedbarFeatureFlagValue: boolean | null,
    RightHandPanelsFeatureFlagValue: boolean,
    LeftNavContextMenuFeatureFlagValue: boolean,
}

const SecurityStore: Module<ISecurityStore, any> = {
    namespaced: true,
    state: {
        UserName: "",
        AvatarVersion: 1,
        Tenant: null,
        UserData: null,
        Tenants: null,
        ModuleSecurity: null,
        ModuleList: null,
        SelectedMember: null,
        ServerSelectionNeeded: true,
        Profiles: [],
        selectedProfile: null,
        selectedRole: null,
        selectedHierarchy: null,
        selectedHierarchyMembers: null,
        previousTenantName: null,
        UserFirstLastName: null,
        almTenants: null,
        AlmFeatureFlagValue: false,
        ToastMessageFeatureFlagValue: false,
        ConfigureHomepagesAggridFeatureFlagValue: false,
        AXLDownloadLinkFeatureFlagValue: false,
        RebrandingStatusBadgesFeatureFlagValue: false,
        HomepageCardDesignerFeatureFlagValue: false,
        ModalDialogsFeatureFlagValue: false,
        TabbedbarFeatureFlagValue: null,
        RightHandPanelsFeatureFlagValue: false,
        LeftNavContextMenuFeatureFlagValue: false,
    },
    getters: {
        Profiles: (state: ISecurityStore) => state.Profiles,
        selectedProfile: (state: ISecurityStore) => state.selectedProfile,
        selectedRole: (state: ISecurityStore) => state.selectedRole,
        selectedHierarchy: (state: ISecurityStore) => state.selectedHierarchy,
        selectedHierarchyMembers: (state: ISecurityStore) => state.selectedHierarchyMembers,
        userClientInitials: (state: ISecurityStore) => {
            if (!state.UserFirstLastName) {
                return '...'
            }
            const userNameArray = state.UserFirstLastName.split(' ');
            if (userNameArray.length !== 2) {
                return '...'
            }
            return `${userNameArray[0][0].toUpperCase()} ${userNameArray[1][0].toUpperCase()}`
        },
        Tenants: (state: ISecurityStore) => {
            return state.Tenants;
        },
        almTenants: (state: ISecurityStore) => {
            return state.almTenants;
        },
        AlmFeatureFlagValue: (state: ISecurityStore) => {
            return state.AlmFeatureFlagValue;
        },
        ConfigureHomepagesAggridFeatureFlagValue: (state: ISecurityStore) => {
            return state.ConfigureHomepagesAggridFeatureFlagValue;
        },
        ToastMessageFeatureFlagValue: (state: ISecurityStore) => {
            return state.ToastMessageFeatureFlagValue;
        },
        AXLDownloadLinkFeatureFlagValue: (state: ISecurityStore) => {
            return state.AXLDownloadLinkFeatureFlagValue;
        },
        RebrandingStatusBadgesFeatureFlagValue: (state: ISecurityStore) => {
            return state.RebrandingStatusBadgesFeatureFlagValue;
        },
        HomepageCardDesignerFeatureFlagValue: (state: ISecurityStore) => {
            return state.HomepageCardDesignerFeatureFlagValue;
        },
        ModalDialogsFeatureFlagValue: (state: ISecurityStore) => {
            return state.ModalDialogsFeatureFlagValue;
        },
        TabbedbarFeatureFlagValue: (state: ISecurityStore) => {
            return state.TabbedbarFeatureFlagValue;
        },
        RightHandPanelsFeatureFlagValue: (state: ISecurityStore) => {
            return state.RightHandPanelsFeatureFlagValue;
        },
        LeftNavContextMenuFeatureFlagValue: (state: ISecurityStore) => {
            return state.LeftNavContextMenuFeatureFlagValue;
        }
    },
    mutations: {
        SetUserName(state, UserName: string) {
            state.UserName = UserName;
        },
        setSelectedProfile(state, profile: Profile) {
            state.selectedProfile = profile;
        },
        setSelectedRole(state, role: HierarchySecurity) {
            state.selectedRole = role;
        },
        setSelectedHierarchy(state, selectedHierarchy: DimensionSecurity) {
            state.selectedHierarchy = selectedHierarchy;
        },
        setSelectedHierarchyMembers(state, members: api.MemberInfo[] | null) {
            state.selectedHierarchyMembers = members;
        },
        IncreaseAvatarVersion(state) {
            state.AvatarVersion = state.AvatarVersion + 1;
        },
        SetTenants(state, tenants: api.Tenant[] | null) {
            state.Tenants = tenants;
        },
        SetTenant(state, tenant: api.Tenant | null) {
            state.Tenant = tenant;
        },
        SetUserData(state, userData: api.ExtendedUserData | null) {
            state.UserData = userData;
            if (userData != null)
                state.UserName = userData.userName!;
        },
        SetAlmFeatureFlagValue(state, value: boolean) {
            state.AlmFeatureFlagValue = value;
        },
        SetModuleSecurity(state, moduleSecurity: api.Module[] | null) {
            state.ModuleSecurity = moduleSecurity;
        },
        SetModuleList(state, moduleList: Array<api.Module> | null) {
            state.ModuleList = moduleList;
        },
        SetSelectedMember(state, member: number | null) {
            state.SelectedMember = member;
        },
        SetApiToken(state, apiToken: string) {
            state.UserName = "API Token"
            AuthClient.apiToken = apiToken;
        },
        SetServerSelectionNeeded(state, val: boolean) {
            state.ServerSelectionNeeded = val
        },
        SetProfiles(state, payload: Array<Profile>) {
            state.Profiles = payload;
        },
        SetPreviousTenantName(state, previousTenantName: string | null) {
            state.previousTenantName = previousTenantName;
        },
        SetUserFirstLastName(state, value: string | null) {
            state.UserFirstLastName = value;
        },
        SetAlmTenants(state, value: TenantDTO[]) {
            state.almTenants = value;
        },
        SetConfigureHomepagesAggridFeatureFlagValue(state, value: boolean) {
            state.ConfigureHomepagesAggridFeatureFlagValue = value;
        },
        SetToastMessageFeatureFlagValue(state, value: boolean) {
            state.ToastMessageFeatureFlagValue = value;
        },
        SetAXLDownloadLinkFeatureFlagValue(state, value: boolean) {
            state.AXLDownloadLinkFeatureFlagValue = value;
        },
        SetRebrandingStatusBadgesFeatureFlagValue(state, value: boolean) {
            state.RebrandingStatusBadgesFeatureFlagValue = value;
        },
        SetHomepageCardDesignerFeatureFlagValue(state, value: boolean) {
            state.HomepageCardDesignerFeatureFlagValue = value;
        },
        SetModalDialogsFeatureFlagValue(state, value: boolean) {
            state.ModalDialogsFeatureFlagValue = value;
        },
        SetTabbedbarFeatureFlagValue(state, value: boolean) {
            state.TabbedbarFeatureFlagValue = value;
        },
        SetRightHandPanelsFeatureFlagValue(state, value: boolean) {
            state.RightHandPanelsFeatureFlagValue = value;
        },
        SetLeftNavContextMenuFeatureFlagValue(state, value: boolean) {
            state.LeftNavContextMenuFeatureFlagValue = value;
        }
    },
    actions: {
        async Login(context, prefferedTenant: string) {
            var auth_client = AuthClient.getInstance();
            await auth_client.ensureToken();
            if (AuthClient.accessToken == null)
                await auth_client.login(window.location.hash.replace("#/", ""));

            if (AuthClient.apiToken == null || AuthClient.apiToken === "anaplan") {
                if (AuthClient.accessToken == null && AuthClient.apiToken !== "anaplan")
                    return; // the login code will kick in and redirect the user to the log in page...

                //await auth_client.ensureToken();
                if (auth_client.state != null && auth_client.state != "") {
                    router.push(auth_client.state);
                }
                context.commit("SetUserName", AuthClient.account!.userName);
                context.commit('SetUserFirstLastName', AuthClient.account!.name);
                context.dispatch("SetCustomTheme", { theme: Themes.ThemeLight, defaultTheme: true }, { root: true });
                console.log("Security/Login - Username is: " + AuthClient.account?.userName);
            }

            var client = new api.SecurityClient(auth_client);
            console.log("Security/Login - getting tenants");
            var tenants = await client.getUserTenants();
            tenants.forEach(t => {
                if (t.environment == null) t.environment = "Unknown";
            });
            context.commit("SetTenants", tenants);
            context.dispatch("NewLocalizer", null, { root: true });

            if (prefferedTenant != null) {
                prefferedTenant = prefferedTenant.toLowerCase();
                for (let idx in tenants) {
                    let tenant = tenants[idx];
                    if (tenant.name != null && tenant.name.toLowerCase() === prefferedTenant) {
                        await context.dispatch("SelectTenant", tenant);
                        break;
                    }
                }
            }
            else if (tenants.length === 1) {
                await context.dispatch("SelectTenant", tenants[0]);
            }
        },

        async LoadUserTenants(context) {
            var auth_client = AuthClient.getInstance();
            await auth_client.ensureToken();

            var client = new api.SecurityClient(auth_client);
            console.log("Security/Login - getting tenants");
            var tenants = await client.getUserTenants();
            tenants.forEach(t => {
                if (t.environment == null) t.environment = "Unknown";
            });
            context.commit("SetTenants", tenants);

            if (context.state.Tenant != null)
                for (var i = 0; i < length; i++)
                    if (tenants[i].name == context.state.Tenant.name) {
                        await context.dispatch("SelectTenant", tenants[i]);
                        return;
                    }
            await context.dispatch("SelectTenant", null);

        },

        async SelectTenant(context, tenant: api.Tenant) {
            console.log("Security/SelectTenant - " + tenant?.name);
            context.commit("SetTenant", tenant);
            if (tenant !== null && tenant.name != null && tenant.webApiUrl != null)
                AuthClient.setTenant(tenant);
            else {
                const baseUrl = AuthClient.configuration.apiBaseUrl;
                AuthClient.setTenant(tenant);
                AuthClient.configuration.apiBaseUrl = baseUrl;
                context.commit("SetUserData", null);
                return;
            }

            context.commit("models/SetFixTenantSwitchModelsAsyncRaceFlag", null, { root: true });
            const fixTenantSwitchModelsAsyncRaceFlag = await context.dispatch("models/LoadFixTenantSwitchModelsAsyncRaceFlag", null, { root: true });
            if (fixTenantSwitchModelsAsyncRaceFlag) {
                context.commit("models/ResetTenantScopedState", null, { root: true });
                context.commit("models/IncrementLoadRequestEpoch", null, { root: true });
            }

            const almFlagValue = await getALMFeatureFlagValue();
            context.commit("SetAlmFeatureFlagValue", almFlagValue);
            var toastMessageFlagValue = await getToastMessageFeatureFlagValue();
            context.commit("SetToastMessageFeatureFlagValue", toastMessageFlagValue);
            const leftNavContextMenuFlagValue = await getLeftNavContextMenuFeatureFlagValue();
            context.commit("SetLeftNavContextMenuFeatureFlagValue", leftNavContextMenuFlagValue);
            var auth_client = AuthClient.getInstance();
            var client = new api.SecurityClient(auth_client);
            var userData = await client.getUserData();
            context.commit("SetUserData", userData);
            if (userData.themeName) {
                await context.dispatch("SetCustomTheme", { theme: userData.themeName, defaultTheme: false }, { root: true });
            } else {
                await context.dispatch("SetCustomTheme", { theme: Themes.ThemeLight, defaultTheme: true }, { root: true });
            }
            if (userData.welcomeMessage)
                await this.dispatch("ShowToast", new api.ToastNotification({
                    message: userData.welcomeMessage,
                    type: api.ToastType.Info
                }));

            await context.dispatch("LoadModuleList");

            var moduleAccess = await client.getEffectiveModuleSecurity();
            context.commit("SetModuleSecurity", moduleAccess);

            var modalDialogsFlagValue = await getModalDialogsFeatureFlagValue();
            context.commit("SetModalDialogsFeatureFlagValue", modalDialogsFlagValue);

            var tabbedbarFlagValue = await getTabbedbarFeatureFlagValue();
            context.commit("SetTabbedbarFeatureFlagValue", tabbedbarFlagValue);

            var configureHomepagesAggridFlagValue = await getConfigureHomepagesAggridFeatureFlagValue();
            context.commit("SetConfigureHomepagesAggridFeatureFlagValue", configureHomepagesAggridFlagValue);

            var axlDownloadLinkFlagValue = await getAXLDownloadLinkFeatureFlagValue();
            context.commit("SetAXLDownloadLinkFeatureFlagValue", axlDownloadLinkFlagValue);

            var rebrandingStatusBadgesFlagValue = await getRebrandingStatusBadgesFeatureFlagValue();
            context.commit("SetRebrandingStatusBadgesFeatureFlagValue", rebrandingStatusBadgesFlagValue);

            var homepageCardDesignerFlagValue = await getHomepageCardDesignerFeatureFlagValue();
            context.commit("SetHomepageCardDesignerFeatureFlagValue", homepageCardDesignerFlagValue);

            var rightHandPanelsFlagValue = await getRightHandPanelsFeatureFlagValue();
            context.commit("SetRightHandPanelsFeatureFlagValue", rightHandPanelsFlagValue);

            context.commit("NewNotificationHandler", null, { root: true });
            context.dispatch("NewLocalizer", null, { root: true });

            await context.dispatch("chat/LoadHelpArticles", null, { root: true });
        },

        async LoadModuleList(context) {
            var auth_client = AuthClient.getInstance();
            var client = new api.SecurityClient(auth_client);
            var moduleList = await client.getModuleList();
            context.commit("SetModuleList", moduleList);
        },

        async LoadModuleSecurity(context) {
            var auth_client = AuthClient.getInstance();
            var client = new api.SecurityClient(auth_client);
            var moduleAccess = await client.getEffectiveModuleSecurity();
            context.commit("SetModuleSecurity", moduleAccess);
        },

        async LoadProfiles(context, auth_client: AuthClient | null = null) {
            if (auth_client == null) {
                auth_client = AuthClient.getInstance();
                await auth_client.ensureToken();
            }
            const client = new api.SecurityClient(auth_client);
            const profiles = await client.getDimensionSecurityProfiles();
            const profilesInstances = profiles.map(p => new Profile(p));
            context.commit('SetProfiles', profilesInstances);
        },

        async LogOut(context) {
            const token = AuthClient.accessToken;
            if (token) {
                const logoutUrl = `${AuthClient.configuration.apiBaseUrl}/Security/logout`;
                fetch(logoutUrl, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'tenant': localStorage.getItem("tenantName") ?? ''
                    },
                    keepalive: true,
                    body: JSON.stringify({})
                }).catch(() => {
                    // Ignore errors since page might be unloading
                });
            }

            if (AuthClient.isAnaplanLogin) return;
            const auth_client = AuthClient.getInstance();
            await auth_client.logout();
        },

        async SwitchUser(context) {
            try {
                var auth_client = AuthClient.getInstance();
                auth_client.ensureToken();
                var client = new api.SecurityClient(auth_client);
                await client.logout()
            }
            catch { }
            var auth_client = AuthClient.getInstance();
            await auth_client.forceLogin();
        },
        async getAlmTenants(context) {
            try {
                const auth_client = AuthClient.getInstance();
                auth_client.ensureToken();
                const client = new api.LandscapeManagementClient(auth_client);
                const tenants = await client.getTenants();
                context.commit('SetAlmTenants', tenants);
            }
            catch (e) {
                console.error(e);
            }
        }
    }
};

export default SecurityStore;
